import ApplicationController from '../application_controller'

class SingleSubmitController extends ApplicationController {
  static targets = ['button']

  connect () {
    this.submitting = false
  }

  submit (event) {
    if (this.submitting) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    this.submitting = true
    this.buttonTargets.forEach(button => { button.disabled = true })
  }
}

export default SingleSubmitController
